import styled from "styled-components";

export const MapContainer = styled.div`
  width: 100%;
  height: 300px;
`;